<template>
    <div>
        <kgr-searchable-dropdown
            ref="dropdown"
            display="fullName"
            :label="label"
            :value="value"
            :options="employees"
            :loading="loading"
            :default-text="defaultText"
            :inline="inline"
            @post-input="onInput"
        />
    </div>
</template>

<script>
import ClubEmployee from '../../../../js/dto/ClubEmployee';
import ClubEmployeeRepository from '../../../../js/repository/ClubEmployeeRepository';
import SearchableDropdown from './SearchableDropdown.vue';

export default {
    components: {
        'kgr-searchable-dropdown': SearchableDropdown,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        value: {
            type: ClubEmployee,
            required: false,
            default: null,
        },
        excludedIds: {
            type: Array,
            required: false,
            default: () => {
                return []
            },
        },
        defaultText: {
            type: String,
            required: false,
            default: null,
        },
        hideLabel: {
            type: Boolean,
            required: false,
            default: false,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loading: true,
            employees: [],
        }
    },
    computed: {
        label() {
            return this.hideLabel ? null : this.$t('department');
        },
    },
    created() {
        this.reload();
    },
    methods: {
        reload() {
            ClubEmployeeRepository
                .findAllByClub(this.clubId)
                .then(data => {
                    this.loading = false;
                    this.employees = data;
                })
                .catch(() => this.$notify.error('error.loadingData'));
        },
        resetSelected() {
            this.$refs.dropdown.selected = null;
            this.$refs.dropdown.searchFilter = '';
        },
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        }
    }
}
</script>
